import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=0a27c7da&"
import script from "./Manifest.vue?vue&type=script&lang=js&"
export * from "./Manifest.vue?vue&type=script&lang=js&"
import style0 from "./Manifest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports